import { React, useState, useEffect } from 'react'
import styles from './GenderAgePanel.module.scss'
import ColumnChart from '../../../components/ColumnChartAllergies'
import GenderAge from '../../../components/ColumnChartAllergies/GenderAgeDetails'
import { useGeoFetch,useGeoState } from '../../../components/GeoProvider'
import ErrorMessage from '../../../components/Layout/ErrorMessage'
import { useAuthState } from '../../../components/AuthProvider'
import Spinner from '../../../components/Loader/Spinner'
const GenderAgeView = ({ geo_type, geo_id}) => {
  const {locationName,displayDate,diseaseSelected} =useGeoState()
  const [genderAge, setGenderAge] = useState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [isLoading,setIsLoading] =useState(false)

  const { data: genderAgeData, error: genderAgeDataError } = useGeoFetch(
    displayDate,
    displayDate,
    `allergiesgenderage/${geo_type}/${diseaseSelected}`,
    '',
    '',
    {
      'geo_id'  : geo_id
    }
  )

  useEffect(() => {
    setIsLoading(true)
    if (genderAgeData !== null && genderAgeData !== undefined) {
      if (genderAgeData.response_code === 200) {       
        setGenderAge(genderAgeData.response_data)
        seterrorOccured(false)

      } else {
        setErrorCode(genderAgeData.response_code)
        setErrorMessage(genderAgeData.response_message)
        setErrorSubject(genderAgeData.response_subject)
        seterrorOccured(true)
      }
      setIsLoading(false)
    }
  }, [genderAgeData])


  if ( errorOccured || genderAgeDataError) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={''}
        errorSubject={errorSubject}
        errorDetails={errorMessage+' for Age & Gender Graph'}
      />
    )
  }

  return  (
    <div className={styles.base}>
      <div className={styles.maindivFormat}>
      <div className={styles.headerDiv}> 
          <div className={styles.captionFormat}>
          Age & Gender
          {/* <p className={styles.subCaptionFormat}>
          Age and gender of individuals with viral respiratory conditions during the last month. 
            </p> */}
          </div>
        </div>
        <div>
          {genderAge !== undefined&&!isLoading ? (
              <>
              <ColumnChart data={[genderAge]} 
              chartName="genderAgechart"
              renderType="dashboard"  
              locationName={locationName} 
              displayDate={displayDate}
             />
             <GenderAge 
              data={[genderAge]} 
             />
              </>
          ) : <Spinner/>}
        </div>
      </div>
    </div>
  )
}

export default GenderAgeView
